<div
  (openChange)="dropdownOpenChangeHandler($event)"
  display="dynamic"
  ngbDropdown
  placement="bottom-end bottom-start bottom-center top-center top-end top-start"
>
  <div (keydown)="onKeydownEvent($event)" [class.active]="highlighted" [class.header-tab--readonly]="!changeable"
       class="highlightable-header-tab py-4 ms-3 ms-md-5 d-flex justify-content-center flex-column"
       data-cy="country-selector-toggle"
       ngbDropdownToggle>
    <div *ngIf="isocode" [tabIndex]="0" class="d-flex align-items-center focusable-round p-1" role="combobox"
         [title]="'countrySelector.countrySwitcherTitle' | cxTranslate"
         [attr.aria-label]="'countrySelector.countrySwitcherTitle' | cxTranslate">
      <span [attr.data-cy]="'flag-' + isocode"
            class="ds-flag--round--{{isocode.toLowerCase()}} ds-flag--round--big country-selector--flag"></span>
      <div class="country-selector--isocode-wrapper mx-1">
        <span
          class="highlightable-header-tab__text test-class text-uppercase ds-fine-print ds-font--regular">{{currentLanguage}}</span>
      </div>
    </div>
  </div>
  <div *ngIf="changeable" class="mx-3 country-selector--dropdown ngbdropdown-mobile-adjustment"
       data-cy="country-selector-dropdown" ngbDropdownMenu>
    <div class="my-4 ms-3">
      <div class="d-flex justify-content-between">
        <h3 class="ds-heading--s">{{'countrySelector.countryRegion' | cxTranslate}}</h3>
        <div class="badge rounded-pill bg-light px-2 d-flex align-items-center color-grey-2">
          {{'countrySelector.englishOnly' | cxTranslate}}
        </div>
      </div>
      <div class="mt-3 ds-fine-print">
        {{'countrySelector.selectCountryDescription' | cxTranslate}}
      </div>
    </div>
    <ds-combo-box-dropdown
      (valueChange)="valueChangeHandler($event)"
      [hideSearchPlaceholderWhenFilled]="true"
      [hideSearchPlaceholderWhenFocused]="false"
      [searchPlaceholder]="'countrySelector.searchPlaceholder' | cxTranslate"
      class="mb-4">
      <ds-combo-box-dropdown-group class="mt-2" maxHeight="12.5rem">
        <ds-combo-box-dropdown-option
          *ngFor="let country of countries"
          [attr.data-cy]="'list-country'"
          [isActive]="country.isocode.toLowerCase() === isocode.toLowerCase()"
          [label]="country.name"
          [value]="country.isocode"
          class="me-1 ms-3">
          <div class="d-flex flex-nowrap justify-content-start align-items-center">
            <div class="ds-flag-wrapper me-2" data-cy="list-country-flag">
              <span class="ds-flag--{{country.isocode.toLowerCase()}}"></span>
            </div>
            <span
              [innerHTML]="country.name | textSearchHighlight:
              (comboBoxDropdownList && comboBoxDropdownList.first) ? comboBoxDropdownList.first.searchInput : ''"
              class="ds-color--grey-1"
              data-cy="list-country-name">{{ country.name }}</span>
          </div>
        </ds-combo-box-dropdown-option>
      </ds-combo-box-dropdown-group>
    </ds-combo-box-dropdown>
    <dcp-country-switch-modal #countrySwitchModalComponent [countries]="countries"></dcp-country-switch-modal>
  </div>
</div>
